import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { CrispChat } from "~/components/child/crisp-chat";
import { KnowledgeBase } from "~/components/child/knowledge-base";
import { Page, PageHeader } from "~/components/shell/page";
import { isParent, meQueryOptions } from "~/lib/api/me";
import { audienceOf, categoriesFor } from "~/lib/knowledge-base";
import { KNOWLEDGE_BASE } from "~/lib/knowledge-content";

export const Route = createFileRoute("/_authenticated/kennisbank")({
  component: KnowledgeBasePage,
});

function KnowledgeBasePage() {
  const { data: partner } = useSuspenseQuery(meQueryOptions());
  const categories = categoriesFor(KNOWLEDGE_BASE, audienceOf(partner));

  return (
    <Page>
      <PageHeader title="Kennisbank">
        {isParent(partner)
          ? "Antwoorden op vragen over je installateurs en je aandeel."
          : "Antwoorden op veelgestelde vragen over aanmelden, de machtiging, koppelen en uitbetaling."}
      </PageHeader>
      <KnowledgeBase categories={categories} />
      <CrispChat />
    </Page>
  );
}
